<template>
  <or-layout>
    <a-row :gutter="[16, 16]" type="flex" justify="space-between">
      <a-col :span="5">
        <a-button type="primary" @click="tableAdd">创建</a-button>
      </a-col>
      <a-col :span="5">
        <a-input placeholder="机构名字" v-model="keywords" @keyup.enter="tableSearch">
          <a-icon slot="suffix" type="search"></a-icon>
        </a-input>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <div>
      <a-table :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
        @change="onPaginationChange" bordered>
        <a-table-column key="name" title="机构名字" data-index="name" />
        <a-table-column key="address" title="地址" data-index="address" />
        <a-table-column key="org_logo" width="100px;" title="机构LOGO">
          <template slot-scope="item">
            <img style="width: 100px;height: 100px;" v-if="item.org_logo != null" :src="item.org_logo" />
            <span v-else>未上传图片</span>
          </template>
        </a-table-column>
        <a-table-column key="managementname" title="管理员" data-index="managementname" />
        <a-table-column key="status" width="100px;" title="状态">
          <template slot-scope="item">
            <span v-if="item.status == 1">可用</span>
            <span v-if="item.status == 0">已禁用</span>
          </template>
        </a-table-column>
        <a-table-column key="active" width="280px" title="操作">
          <template slot-scope="item">
            <a-button v-if="item.status == 0" @click="changeStatus({ id: item.id, status: 1, management: item.management })"
              class="active_btn" size="small" type="link">启用
            </a-button>
            <a-button v-if="item.status == 1" @click="changeStatus({ id: item.id, status: 0, management: item.management })"
              class="active_btn" size="small" type="link">禁用
            </a-button>
            <a-button v-if="item.status == 1" @click="tableEdit(item)" class="active_btn" size="small" type="link">编辑
            </a-button>
            <router-link :to="{ path: '/orgorganizationinfo', query: { id: item.id } }">查看详情</router-link>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal :visible="visible" title="机构信息" @ok="modalSave" :destroyOnClose="true" @cancel="modalCancel">
      <a-form>
        <a-input type="hidden" v-model="form.id" />
        <a-form-item>
          <a-input v-model="form.name" placeholder="机构名字" />
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.address" placeholder="地址" />
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.gps" placeholder="GPS位置" />
        </a-form-item>
        <a-form-item>
          <or-upload v-model="form.org_logo" mode="image" @input="uploadfile" button-text="上传机构图标" />
        </a-form-item>
        <a-form-item>
          <a-select optionFilterProp="children" show-search v-model="form.management" showSearch placeholder="管理员"
            style="width: 100%;">
            <a-select-option v-for="item in  adminList" :key="item.mobile" :value="item.id">
              {{ item.nickname }}/{{ item.mobile }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </or-layout>
</template>

<script>
import AFormItem from "ant-design-vue/es/form/FormItem";
import OrUpload from "@/components/upload";

export default {
  components: { AFormItem, OrUpload },
  data() {
    return {
      keywords: "",
      data: [],
      pageinfo: { total: 1, current: 1, pageSize: 10 },
      loading: false,
      visible: false,
      adminList: [],
      form: {
        id: undefined,
        name: undefined,
        org_logo: undefined,
        gps: undefined,
        address: undefined,
        management: undefined
      }
    };
  },
  mounted() {
    this.getAdminList();
    this.tableSearch();
  },
  methods: {
    selectItem(pid) {
      this.form.pid = pid;
    },
    changeStatus(data) {
      console.info(data);
      this.$axios
        .post("/api/OrgOrganization/edit", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getTableList();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    onPaginationChange(item) {
      this.pageinfo.current = item.current;
      this.searchbtn();
    },
    uploadfile() {
      console.info("上传文件:", this.form.org_logo);
    },
    tableSearch() {
      this.getTableList({ keyword: this.keywords });
    },
    getAdminList() {
      this.$axios
        .post("/api/Admin/index", { pageinfo: { pageSize: 9999 } })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.adminList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getTableList(data) {
      this.$axios
        .post("/api/OrgOrganization/index", {
          data
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.data = res.data.data;
            this.pageinfo = res.data.pageinfo;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    tableEdit(item) {
      this.form.id = item.id;
      this.form.name = item.name;
      this.form.gps = item.gps;
      this.form.org_logo = item.org_logo;
      this.form.address = item.address;
      this.form.management = item.management
      this.visible = true;
    },

    tableAdd() {
      this.form = {};
      this.visible = true;
    },
    tableDel(data) {
      let _this = this;
      this.$confirm({
        title: "删除权限",
        content: "确认删除当前权限吗?",
        okText: "确认",
        cancelText: "取消",
        onOk: function () {
          _this.$axios
            .post("/api/OrgOrganization/del", { data })
            .then(res => {
              if (res.code != 200) {
                _this.$error({
                  title: "错误",
                  content: res.msg,
                  okText: "确定"
                });
              } else {
                _this.getTableList();
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      });
    },
    modalSave() {
      let url = "/api/OrgOrganization/edit";
      if (!this.form.id) {
        url = "/api/OrgOrganization/add";
      }
      this.$axios
        .post(url, { data: this.form })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getTableList();
            this.visible = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    modalCancel() {
      this.visible = false;
    }
  }
};
</script>
<style>
.active_btn {
  margin-left: 5px;
}
</style>